import {
    DashboardPageContent,
    FormWrapper,
    PageTitle,
} from 'custom-style-components';
import { EventType, People } from 'types/models';
import { Flex, useToast } from '@chakra-ui/react';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import ErrorMessage from 'components/ErrorMessage';
import EventsTable from 'components/EventTable';
import LoadingSpinner from 'components/LoadingSpinner';
import ShowParticipatingUsers from '../../components/ShowParticipatingUsers';
import TOAST from 'constants/TOAST';
import createCancelTokenSource from 'utils/createCancelTokenSource';
import { fetchManyEventsByResponsibleUser } from 'services/fetch/events';
import { fetchManyUsersFromEvent } from 'services/fetch/users';
import { useAuth } from 'hooks/auth';
import { useRouteMatch } from 'react-router-dom';

const ListEvents: React.FC = () => {
    const { user } = useAuth();
    const toast = useToast({
        duration: TOAST.DURATION,
        position: TOAST.DEFAULT_POSITION,
        isClosable: TOAST.CLOSABLE_BY_DEFAULT,
    });

    const [eventList, setEventList] = useState<EventType[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const [eventData, setEventData] = useState({} as EventType);

    const { path } = useRouteMatch();

    const [modalOpen, setModalOpen] = useState(false);

    const source = useRef(createCancelTokenSource());

    const loadEvents = useCallback(() => {
        if (!user) return;
        source.current = createCancelTokenSource();
        setLoading(true);
        fetchManyEventsByResponsibleUser(source.current.token, user.id, {
            limit: Number.MAX_SAFE_INTEGER,
        })
            .then(({ events }) => {
                setEventList(events);
            })
            .catch((err) => {
                setError(err.message);
                toast({
                    title: err.message,
                    status: 'error',
                });
            })
            .finally(() => setLoading(false));
    }, [user, toast]);

    useEffect(() => {
        loadEvents();
        return () => source.current.cancel();
    }, [loadEvents]);

    const handleParticipantsClick = useCallback((event: EventType) => {
        setEventData(event);
        setModalOpen(true);
    }, []);

    return (
        <DashboardPageContent>
            <ShowParticipatingUsers
                event={eventData}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
            />
            <FormWrapper>
                <PageTitle>Edições</PageTitle>

                {error ? (
                    <ErrorMessage>{error}</ErrorMessage>
                ) : eventList && eventList.length > 0 ? (
                    <EventsTable
                        events={eventList}
                        path={path}
                        onDeleteClick={() => {
                            toast({
                                title: 'Ação não permitida',
                                description: 'Apenas administradores podem excluir edições.',
                                status: 'warning'
                            });
                        }}
                        onParticipantsClick={handleParticipantsClick}
                    />
                ) : loading ? (
                    <Flex justify="center" p={10}>
                        <LoadingSpinner />
                    </Flex>
                ) : (
                    <ErrorMessage>Nenhum resultado encontrado.</ErrorMessage>
                )}
            </FormWrapper>
        </DashboardPageContent>
    );
};

export default ListEvents;
